import { createAction } from '@lingoda/core';

export default createAction('time/INIT_ASYNC_TIME');
